import { useCallback } from 'react';

import { useHistory,useRouteMatch } from 'react-router-dom';

const useFullUrl = () => {
  const { url: currentUrl } = useRouteMatch();
  const history = useHistory();

  const divider = '/-';
  const root = currentUrl.split(divider)[0];

  const goToPath = useCallback((pathToLoad, state) => {
    const fullUrl = `${root}${divider}/${pathToLoad}`;

    return history.push(fullUrl, state);
  }, [history, root]);

  return {
    goToPath,
  };
};

export default useFullUrl;
